/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailTemplateType
 */
export interface MailTemplateType {
    /**
     * 
     * @type {number}
     * @memberof MailTemplateType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MailTemplateType
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof MailTemplateType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MailTemplateType
     */
    lang?: MailTemplateTypeLangEnum;
}

/**
* @export
* @enum {string}
*/
export enum MailTemplateTypeLangEnum {
    Ja = 'Ja',
    En = 'En'
}

export function MailTemplateTypeFromJSON(json: any): MailTemplateType {
    return MailTemplateTypeFromJSONTyped(json, false);
}

export function MailTemplateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailTemplateType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'lang': !exists(json, 'lang') ? undefined : json['lang'],
    };
}

export function MailTemplateTypeToJSON(value?: MailTemplateType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'lang': value.lang,
    };
}


